import type { ReactNode } from "react";
import { CircleAlertIcon, InboxIcon } from "lucide-react";

import { CardContent } from "./card";
import { SurfaceCard } from "./surface-card";
import { cn } from "../../lib/utils";

type EmptyStateProps = {
  title: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
  className?: string;
  compact?: boolean;
  tone?: "neutral" | "danger";
  surface?: boolean;
};

export function EmptyState({
  title,
  description,
  icon,
  action,
  className,
  compact = false,
  tone = "neutral",
  surface = true,
}: EmptyStateProps) {
  const resolvedIcon =
    icon ?? (tone === "danger" ? <CircleAlertIcon className='size-4' /> : <InboxIcon className='size-4' />);

  const content = (
    <>
      <CardContent className={cn("flex flex-col items-center gap-2 text-center text-sm", compact ? "p-4" : "p-6")}>
        <div
          className={cn(
            "flex size-8 items-center justify-center rounded-full",
            tone === "danger" ? "bg-destructive/15 text-destructive" : "bg-muted text-muted-foreground",
          )}
        >
          {resolvedIcon}
        </div>
        <div className='space-y-1'>
          <p className='font-medium'>{title}</p>
          {description ? <p className='text-muted-foreground'>{description}</p> : null}
        </div>
        {action ? <div className='pt-1'>{action}</div> : null}
      </CardContent>
    </>
  );

  if (!surface) {
    return <div className={cn("bg-transparent", className)}>{content}</div>;
  }

  return <SurfaceCard className={className}>{content}</SurfaceCard>;
}
